import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { settingsApi } from '../../api';
import './Sidebar.css';
import { useState, useEffect } from 'react';

const NAV_ITEMS = [
  { to: '/', label: 'Dashboard', icon: '⬡', roles: ['admin', 'manager', 'staff', 'tailor'] },
  { to: '/suppliers', label: 'Suppliers', icon: '👥', roles: ['admin', 'manager', 'staff'] },
  { to: '/inventory', label: 'Inventory', icon: '📦', roles: ['admin', 'manager', 'staff'] },
  { to: '/accessories', label: 'Accessories', icon: '🧵', roles: ['admin', 'manager', 'staff'] },
  { to: '/orders', label: 'Orders', icon: '📋', roles: ['admin', 'manager', 'staff'] },
  { to: '/customers', label: 'Customers', icon: '👥', roles: ['admin', 'manager', 'staff'] },
  { to: '/tailors', label: 'Tailors', icon: '✂️', roles: ['admin', 'manager', 'staff'] },
  { to: '/assignments', label: 'My Assignments', icon: '🎯', roles: ['tailor'] },
  { to: '/tailor-history', label: 'Tailor History', icon: '🧵', roles: ['admin', 'manager', 'staff'] },
  { to: '/reports', label: 'Reports', icon: '📊', roles: ['admin', 'manager'] },
  { to: '/users', label: 'Users', icon: '👤', roles: ['admin'] },
  // { to: '/category', label: 'Category', icon: '🏷️', roles: ['admin'] },
  { to: '/settings', label: 'General Settings', icon: '⚙️', roles: ['admin'] },
];

export default function Sidebar({ open = true, onClose = () => { } }) {
  const { user, logout, hasRole } = useAuth();
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth <= 768 : false);
  const [companyLogo, setCompanyLogo] = useState(null);
  const [companyName, setCompanyName] = useState(null);

  // Fetch company logo from settings
  useEffect(() => {
    fetchCompanyLogo();
  }, []);

  const fetchCompanyLogo = async () => {
    try {
      const res = await settingsApi.get();
      if (res.data && res.data.data) {
        const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';
        const BASE_URL = API_URL.replace('/api/v1', '');
        const data = res.data.data;
        if (data.company_logo) {
          setCompanyLogo(`${BASE_URL}${data.company_logo}`);
        }
        if (data.company_name) {
          setCompanyName(data.company_name);
        }
      }
    } catch (err) {
      console.error('Failed to fetch company settings:', err);
    }
  };

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  const location = useLocation();

  const visibleItems = NAV_ITEMS.filter((item) => hasRole(...item.roles));

  return (
    <>
      {open && isMobile && <div className="sidebar-backdrop" onClick={onClose} />}
      <aside className={`sidebar ${open ? 'open' : ''}`}>
        {/* Brand */}
        <div className="sidebar-brand">
          <div className="sidebar-logo">
            {companyLogo ? (
              <img src={companyLogo} alt="Company Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
            ) : (
              '✂'
            )}
          </div>
          <div className="sidebar-brand-text">
            <span className="sidebar-brand-name">{companyName || 'RCITMS'}</span>
            <span className="sidebar-brand-sub">Tailoring System</span>
          </div>
          <button className="sidebar-close" onClick={onClose} aria-label="Close menu">✕</button>
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          <div className="sidebar-nav-label">Navigation</div>
          {visibleItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `sidebar-link ${isActive ? 'active' : ''}`
              }
              onClick={() => { if (isMobile) onClose(); }}
            >
              <span className="sidebar-link-icon">{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        {/* User section */}
        <div className="sidebar-user">
          <div className="sidebar-user-info">
            <div className="sidebar-avatar">
              {user?.name?.[0]?.toUpperCase() || 'U'}
            </div>
            <div className="sidebar-user-text">
              <div className="sidebar-user-name">{user?.name}</div>
              <div className={`badge badge-${user?.role}`}>{user?.role}</div>
            </div>
          </div>
          <button className="sidebar-logout" onClick={logout} title="Logout">
            ⏻
          </button>
        </div>
      </aside>
    </>
  );
}
